import CompanyAPI from 'dashboard/api/companies';
import { createStore } from 'dashboard/store/storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import camelcaseKeys from 'camelcase-keys';

export const useCompaniesStore = createStore({
  name: 'companies',
  type: 'pinia',
  API: CompanyAPI,
  getters: {
    getCompaniesList: state => {
      return camelcaseKeys(state.records, { deep: true });
    },
  },
  actions: () => ({
    async search({ search, page, sort }) {
      this.setUIFlag({ fetchingList: true });
      try {
        const {
          data: { payload, meta },
        } = await CompanyAPI.search(search, page, sort);
        this.records = payload;
        this.setMeta(meta);
      } catch (error) {
        throwErrorMessage(error);
      } finally {
        this.setUIFlag({ fetchingList: false });
      }
    },

    async createCompany(companyData) {
      this.setUIFlag({ creatingItem: true });
      try {
        const { data } = await CompanyAPI.create(companyData);
        const record = data.payload || data;
        this.records = [record, ...this.records];
        return record;
      } catch (error) {
        throwErrorMessage(error);
        throw error;
      } finally {
        this.setUIFlag({ creatingItem: false });
      }
    },

    async updateCompany({ id, ...companyData }) {
      this.setUIFlag({ updatingItem: true });
      try {
        const { data } = await CompanyAPI.update(id, companyData);
        const record = data.payload || data;
        this.records = this.records.map(r => (r.id === id ? record : r));
        return record;
      } catch (error) {
        throwErrorMessage(error);
        throw error;
      } finally {
        this.setUIFlag({ updatingItem: false });
      }
    },

    async deleteCompany(id) {
      this.setUIFlag({ deletingItem: true });
      try {
        await CompanyAPI.delete(id);
        this.records = this.records.filter(r => r.id !== id);
      } catch (error) {
        throwErrorMessage(error);
        throw error;
      } finally {
        this.setUIFlag({ deletingItem: false });
      }
    },

    async importCompanies(file) {
      await CompanyAPI.import(file);
    },

    async exportCompanies() {
      await CompanyAPI.export();
    },
  }),
});
